import React from 'react';
import { Card, Table } from 'antd';
import { ValidRankingItem } from '../../../services/financeService';

interface ProfitRankingTableProps {
    rankingData: ValidRankingItem[];
    loading: boolean;
}

export const ProfitRankingTable: React.FC<ProfitRankingTableProps> = ({ rankingData, loading }) => {
    const columns = [
        { title: 'SKU', dataIndex: 'seller_sku__sku_code', key: 'sku' },
        { title: '名称', dataIndex: 'seller_sku__product_name', key: 'name', ellipsis: true },
        {
            title: '销售额',
            dataIndex: 'revenue',
            key: 'revenue',
            render: (val: number) => `$${Number(val).toFixed(2)}`,
            sorter: (a: any, b: any) => a.revenue - b.revenue
        },
        {
            title: '毛利润',
            dataIndex: 'profit',
            key: 'profit',
            render: (val: number) => (
                <span style={{ color: val >= 0 ? '#3f8600' : '#cf1322' }}>
                    ${Number(val).toFixed(2)}
                </span>
            ),
            sorter: (a: any, b: any) => a.profit - b.profit,
            defaultSortOrder: 'descend' as const
        },
        {
            title: '利润率',
            dataIndex: 'avg_margin',
            key: 'margin',
            render: (val: number) => `${Number(val).toFixed(1)}%`
        },
        { title: '销量', dataIndex: 'units', key: 'units' },
    ];

    return (
        <Card title="SKU 利润排行 TOP 10" bordered={false} loading={loading}>
            <Table
                dataSource={rankingData}
                columns={columns}
                rowKey="seller_sku"
                pagination={false}
                size="small"
            />
        </Card>
    );
};
